var exports = {
  "gP": "EmbedVideo.module__videoOverlay___aHh1YW",
  "yH": "EmbedVideo.module__playButtonWrapper___aHh1YW",
  "SK": "EmbedVideo.module__thumbnailPlaceholder___aHh1YW",
  "aO": "EmbedVideo.module__thumbHashPlaceholder___aHh1YW",
  "mZ": "EmbedVideo.module__metadataProbe___aHh1YW",
  "tN": "EmbedVideo.module__blurContainer___aHh1YW",
  "rj": "EmbedVideo.module__blurContent___aHh1YW",
  "UF": "EmbedVideo.module__blurInner___aHh1YW",
  "Y3": "EmbedVideo.module__blurThumbnail___aHh1YW",
  "il": "EmbedVideo.module__mediaContainer___aHh1YW",
  "AA": "EmbedVideo.module__mobileContainer___aHh1YW",
  "SY": "EmbedVideo.module__videoPlayerWrapper___aHh1YW",
  "s": "EmbedVideo.module__videoPlayerBlock___aHh1YW",
  "Qh": "EmbedVideo.module__videoPlayerFill___aHh1YW",
  "hz": "EmbedVideo.module__inlineVideo___aHh1YW",
  "nD": "EmbedVideo.module__inlineMuteButton___aHh1YW",
};

module.exports = exports;
